import React , {useEffect, useRef , useState} from 'react';
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {isAuthenticatedSelector} from "./store/user/user.selector.js";
import {filterRoutesByAuthStep} from "./configs/routes.js";
import {initFlowbite} from "flowbite";
import { useTranslation } from 'react-i18next';
import {setLng} from "./store/common/common.reducer";
import Layout from "./components/Layout";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {Get} from "./apis/api";
import {setting} from "./store/setting/setting.reducer";


const App = () => {
  const scrollRef = useRef(null);
  const { pathname } = useLocation();
  const isAuth = useSelector(isAuthenticatedSelector);
  const routes = filterRoutesByAuthStep(isAuth);
  const { i18n } = useTranslation();
  const dispatch = useDispatch()
  const navigate = useNavigate();

  const user = useSelector((state) => state.user.user)



  const directionClass = i18n.dir() === 'rtl' ? 'rtl' : 'ltr';
  useEffect(() => {
    document.documentElement.dir = i18n.dir();
    dispatch(setLng(i18n.language))
   }, [i18n , directionClass]);

  const pathName = useLocation()
  useEffect(() => {
    initFlowbite()
  } , [pathName])

  const changeLanguage = () => {
     i18n.changeLanguage("en").then((res) =>{
      console.log(res)
    });
  };

  useEffect(() => {
    if(pathname?.includes("/crew/auth") || (user?.role_key === "crew" ||  (!user?.role_key && user?.role_key))) {
      changeLanguage()
    }
    if(!isAuth && !pathname?.includes("auth")) {
      navigate("/auth/login")
    } else {
      Get("basic-information/province" ).then((res) =>{
        dispatch(setting({province : res?.details?.data?.data}))
      }).catch((err) => {

      })
      Get("basic-information/city" ).then((res) =>{
        dispatch(setting({city : res?.details?.data?.data}))
      }).catch((err) => {

      })

      Get("basic-information/country" ).then((res) =>{
        dispatch(setting({country : res?.details?.data?.data}))
      }).catch((err) => {

      })
    }
  } , [])


  useEffect(() => {
    scrollRef.current?.scrollIntoView?.({ behavior: 'smooth' });
  }, [pathname]);

  return (
    <div className={directionClass +`${directionClass !== 'rtl'  ? " en " : " "} `}>
      <div ref={scrollRef} />
      {
          <Layout>
            <Routes>
              {routes.map((item) => (
                <Route key={item.route} path={item.route} element={item.Element} />
              ))}
            </Routes>
            <ToastContainer
              className="impct-toast"
              position="top-right"
              autoClose={3000}
              hideProgressBar
              newestOnTop
              closeOnClick
              rtl={true}
              pauseOnVisibilityChange
              draggable={false}
              pauseOnHover
              toastClassName={'font-yekan'}
              bodyClassName={'font-yekan'}
            />
          </Layout>
      }

    </div>
  );
};

export default App;
